import styles from './List.module.scss';
import cn from "classnames";

export const List = ({arr, handler, type}) => {
    const listElements = arr.map((item) => {
        const {id, name, desc, success} = item;

        return(
            <div key={id} className={styles.element} onClick={e => handler(type, id, success, e)}>
                <img src={`${process.env.PUBLIC_URL}/elements/${type === 'right' ? 'items' : 'characters'}/${id}.jpg`} alt={name} className={styles.pic}/>
                <div className={styles.text}>
                    <div className={cn(styles.name, 'text-body')}>{name}</div>
                    <div className={cn(styles.desc, 'text-small')}>{desc}</div>
                </div>
            </div>
        )
    });

    return (
        <div className={cn(`${type}`, styles[type])}>
            {listElements}
        </div>
    )
}